export default __webpack_public_path__ + "static/slider-pp-8400fbd890cd4ab720eb752c21cb7527.jpg";